import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { DialogData } from '../../manager/calendar/dialogs/form-dialog/form-dialog.component';
import { UserManagementService } from 'src/app/services/user_management/user-management.service';

@Component({
  selector: 'app-view-documents',
  templateUrl: './view-documents.component.html',
  styleUrls: ['./view-documents.component.scss']
})
export class ViewDocumentsComponent {
  public imagePath;
  constructor(public sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<ViewDocumentsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,private userService:UserManagementService){}
  ngOnInit(): void {
    this.onView(this.data)
  }
  onView(url){
    let data = {
      file: url
  }
  this.userService.viewDoc(data).subscribe((data: any) => {
      // this.iFrameURL
      if (data.status == 200) {
         this.imagePath=data.msg
      }
  })
  }
}
